import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MotifModal, ModalSizes } from '@ey-xd/ng-motif';
import { KeyMetricsComponent } from 'src/app/components/key-metrics/key-metrics.component';
import { Competency, Engagement } from 'src/app/interfaces/home.interface';
import { HomeService } from 'src/app/services/home/home.service';

@Component({
  selector: 'app-engagement-list',
  templateUrl: './engagement-list.component.html',
  styleUrls: ['./engagement-list.component.scss'],
})
export class EngagementListComponent implements OnInit {
  public engagements!: Competency;
  public engagementRevenue: number = 0;
  public engagementId!:any;
  loading: boolean = false;
  public headerList: Array<any> = [
    {
      label: 'Engagement Name',
      colDef: { fieldName: 'engagementName'},
    },
    {
      label: '',
      colDef: { fieldName: 'action'},
    },
  ];

  constructor(
    private homeServiceRef: HomeService,
    private route: ActivatedRoute,
    private router:Router,
    public modal: MotifModal,
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.engagementId = id;
    this.loading = true;
    if (id)
      this.homeServiceRef.getEngagements(id).subscribe((res) => {
        this.engagements = res;
        Object.values(res).map((v: any, k, arr) => {
           this.engagementRevenue = v.reduce((acc:number, obj: Engagement) => {
            return acc + obj.revenuePerYear;
           }, this.engagementRevenue)
        });
        this.loading = false;
      });
  }

  redirectEngagementDetails(engagementName:any){
    this.router.navigate([`/engagementdetails`, engagementName, this.engagementId]);
  }
  openDetailsModal(engagementName: string){
    const modalRef = this.modal.open(KeyMetricsComponent, {
      size: ModalSizes.XL,
      width: '80vw',
      data: {'name':engagementName, clientId: this.engagementId}
    });
    modalRef.componentInstance.data = {'name':engagementName, clientId: this.engagementId};
    modalRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
}